module.exports = __webpack_public_path__ + "img/huanbao1.8f976977.png";